import React from "react";
import {
	View,
	Text,
	StyleSheet,
	useWindowDimensions,
	Pressable
} from "react-native";
import { useNavigation, useRoute } from "@react-navigation/native";

import { GearIcon, HomeIcon, LogoutIcon } from "./Icons";
import { colors } from "./Shared";
import AuthService from "../services/auth";
import { AntDesign } from "@expo/vector-icons";
import RenderIf from "./RenderIf";

const authService = new AuthService();

interface Props {
	onBack?: () => void;
	onPressSettings: () => void;
	isAdmin: boolean;
}

export default function DashboardHeader({ onPressSettings, onBack, isAdmin }: Props) {
	const window = useWindowDimensions();
	const navigation = useNavigation();
	const route = useRoute();

	return (
		<View style={[styles.container, { height: window.width < 650 ? 55 : 70 }]}>
			<Text style={styles.title}>
				{window.width < 440 ? "Dashboard" : "Recluchat Dashboard"}
			</Text>

			<RenderIf condition={isAdmin}>
				<Pressable
					style={styles.setting}
					onPress={onBack ? onBack : onPressSettings}
				>
					{!onBack && <GearIcon color="#fff" />}
					{onBack && <HomeIcon color="#fff" />}
				</Pressable>
			</RenderIf>

			<RenderIf condition={route.name === 'DashBoard'}>
				<Pressable style={styles.setting} onPress={() => navigation.navigate('Resources')}>
					<AntDesign name="contacts" size={24} color="#fff" />
				</Pressable>
			</RenderIf>

			<RenderIf condition={route.name === 'Resources'}>
				<Pressable style={styles.setting} onPress={() => navigation.navigate('DashBoard')}>
					<AntDesign name="wechat" size={24} color="#fff" />
				</Pressable>
			</RenderIf>

			<Pressable style={styles.setting} onPress={authService.logout}>
				<LogoutIcon color="#fff" />
			</Pressable>
		</View>
	);
}

const styles = StyleSheet.create({
	container: {
		position: "relative",
		width: "100%",
		backgroundColor: colors.bg.primary,
		flexDirection: "row"
	},
	title: {
		flex: 1,
		height: "100%",
		paddingLeft: 10,
		display: "flex",
		alignItems: "center",
		fontSize: 30,
		color: colors.text.white
	},
		setting: {
		position: "relative",
		height: "100%",
		paddingHorizontal: 20,
		display: "flex",
		justifyContent: "center",
		alignItems: "center"
	}
});
